// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__3NR-c","content":"Modal_content__3a0fl","btnCerrar":"Modal_btnCerrar__HEY5R","img":"Modal_img__2NhDd"};